import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch, onMounted, toRefs } from "vue"
import { Settings } from "../constant"
import { Loader } from '@googlemaps/js-api-loader';
import { GoogleMap, CustomMarker, InfoWindow } from 'vue3-google-map';

export default /*@__PURE__*/_defineComponent({
  __name: 'MapPreview',
  props: {
    svgUrl: {},
    NECornerLatitude: {},
    NECornerLongitude: {},
    CenterpointLatitude: {},
    CenterpointLongitude: {},
    SWCornerLatitude: {},
    SWCornerLongitude: {},
    mapZoom: {}
  },
  emits: ["changeZoomLevel"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const loader = new Loader({
  apiKey: 'AIzaSyAFN6T9RwgQ8dEGKzI9QvvXxeC7Bj6z9ME',
  version: 'weekly',
  libraries: ['places'],
});
// Create a promise that resolves to the Google Maps API
const apiPromise = loader.load();
const props = __props
const { svgUrl,
  NECornerLatitude,
  NECornerLongitude,
  CenterpointLatitude,
  CenterpointLongitude,
  SWCornerLatitude,
  SWCornerLongitude,
  mapZoom } = toRefs(props)
const emit = __emit
const mapRef = ref<HTMLElement | null>(null)
const gmap = ref<any>(null)
let overlay = ref<any>(null);
const zoomLevel = ref(mapZoom.value)
watch(zoomLevel, (newZoom) => {
  if (newZoom >= 10 && newZoom <= 20) {
    emit("changeZoomLevel", newZoom)
  }
})
onMounted(async () => {
  await apiPromise;
  const svgContainer = mapSvgContainer()
  // Wait for map element
  if (!mapRef.value) return
  // Define custom overlay
  function VueOverlay(bounds: any, options: any) {
    this.$el = svgContainer;
    this.$bounds = bounds;
    this.$centered = options.centered;
  }
  VueOverlay.prototype = Object.create(window.google.maps.OverlayView.prototype)
  VueOverlay.prototype.constructor = VueOverlay
  VueOverlay.prototype.onAdd = function () {
    this.$el.style.position = "absolute"
    let panes = this.getPanes()
    panes.overlayMouseTarget.appendChild(this.$el)
  }
  VueOverlay.prototype.onRemove = function () {
    this.$el.parentNode.removeChild(this.$el)
  }
  VueOverlay.prototype.draw = function () {
    let overlayProjection = this.getProjection()
    let sw = overlayProjection.fromLatLngToDivPixel(
      this.$bounds.getSouthWest()
    )
    let ne = overlayProjection.fromLatLngToDivPixel(
      this.$bounds.getNorthEast()
    )
    let div = this.$el
    div.style.left = sw.x + "px"
    div.style.top = ne.y + "px"
    div.style.width = ne.x - sw.x + "px"
    div.style.height = sw.y - ne.y + "px"
  }

  const mapElement: HTMLElement = document.getElementById(
        "map"
      ) as HTMLElement;
    gmap.value = new window.google.maps.Map(mapElement,  {
    zoom: mapZoom.value,
    minZoom: Settings.MAP_MIN_SVG_SCALE,
    maxZoom: Settings.MAP_MAX_SVG_SCALE,
    center: {
      lat: +CenterpointLatitude.value,
      lng: +CenterpointLongitude.value,
    },
    disableDefaultUI: true,
    disableDoubleClickZoom: true,
    clickableIcons: false,
  })
  const bounds = new window.google.maps.LatLngBounds(
    new window.google.maps.LatLng(
      SWCornerLatitude.value,
      SWCornerLongitude.value
    ),
    new window.google.maps.LatLng(
      NECornerLatitude.value,
      NECornerLongitude.value
    )
  )
  overlay.value = new (VueOverlay as any)(bounds, {
    centered: true,
    layer: "overlayLayer",
  })
  overlay.value.setMap(gmap.value)
  // Update zoomLevel when user scrolls
  document.getElementById("map"
      ).addEventListener("mousewheel", () => {
    zoomLevel.value = gmap.value.zoom
  })
})

function mapSvgContainer(): HTMLDivElement {
  let div = document.createElement("div")
  div.style.borderStyle = "none"
  div.style.borderWidth = "0px"
  div.style.position = "absolute"
  let img = document.createElement("img")
  img.src = svgUrl.value
  img.style.width = "100%"
  img.style.height = "100%"
  img.style.opacity = "1"
  img.style.position = "absolute"
  div.appendChild(img)
  return div
}
// :small_blue_diamond: Public methods (exposed to parent)
function svgZoom(zoom: number) {
  gmap.value?.setZoom(zoom)
  zoomLevel.value = zoom
}
function svgZoomIn() {
  const currentZoom = gmap.value?.zoom ?? mapZoom.value
  const newZoom = currentZoom + 1
  gmap.value?.setZoom(newZoom)
  zoomLevel.value = newZoom
}
function svgZoomOut() {
  const currentZoom = gmap.value?.zoom ?? mapZoom.value
  const newZoom = currentZoom - 1
  gmap.value?.setZoom(newZoom)
  zoomLevel.value = newZoom
}
function changeZoomHandler() {
  zoomLevel.value = 10
}

// Expose methods to parent
__expose({
  svgZoom,
  svgZoomIn,
  svgZoomOut,
  changeZoomHandler,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(GoogleMap), {
    "api-promise": _unref(apiPromise),
    zoom: _unref(mapZoom),
    center: { lat: +_unref(CenterpointLatitude), lng: +_unref(CenterpointLongitude) },
    disableDefaultUI: true,
    disableDoubleClickZoom: true,
    options: { minZoom: 10, maxZoom: 20 },
    ref_key: "mapRef",
    ref: mapRef,
    id: "map"
  }, null, 8, ["api-promise", "zoom", "center"]))
}
}

})